<template>
  <div v-if="appFlag"></div>
  <div class='intro' v-else-if="active">
    <TypeOneIntro v-if="imgFlag == 0 || !imgFlag"/>
    <TypeTwoIntro v-else-if="imgFlag == 1"/>
    <SingleBtnDialog
      v-if='showSingleBtnDialog'
      :messageType='messageType'
      :onClickConfirmBtn='() => {
        if (this.appFlag) {
          this.$router.push({
            name: "AppMain",
            query: { addressByLotNum: this.$route.query.addressByLotNum } // 지번주소
          })
        } else {
          requestReScan(modnPayUrl)
        }
    }'/>
  </div>
</template>
<script lang='js'>
import Vue from 'vue'
import { INTRO_PAGE_NAME } from '../utils/EndPoint'
import { REQ_MAIN_INDEX, NO_BACK_FLAG_ON, CLEAR_TEMP_CART, SET_HISTORY_FLAG_TRUE, RESET_CATEGORY_CODE } from '@/store/_actions/actionTypes'
import { MSG_RETURN_BACK_BUTTON, MSG_RETURN_BACK_BUTTON_APP } from '@/utils/Message'
import SingleBtnDialog from '@/components/Dialog/SingleBtnDialog.vue'
import { THROW_MAIN, THROW_ORDER, THROW_MENU } from '@/router'

import TypeOneIntro from '@/components/Intro/TypeOneIntro.vue'
import TypeTwoIntro from '@/components/Intro/TypeTwoIntro.vue'

export default Vue.extend({
  name: INTRO_PAGE_NAME,
  components: { SingleBtnDialog, TypeOneIntro, TypeTwoIntro },
  data () {
    return {
      MSG_RETURN_BACK_BUTTON, // 결제하지 않고 BACK BUTTON으로 상품판에 돌아왔을 경우
      modnPayUrl: '', // 모든페이 기본 URL
      showSingleBtnDialog: false, // Single Button Dialog Show Flag
      imgFlag: this.$store.getters.flag, // 인트로 이미지 여부
      time: 1500, // 인트로 로딩 시간
      active: 1,
      pageType: '',
      messageType: 0
    }
  },
  created () {
    this.$store.dispatch(CLEAR_TEMP_CART)
    this.$store.dispatch(SET_HISTORY_FLAG_TRUE)
    sessionStorage.setItem('url', window.location.href)
    this.setIntro()
  },
  methods: {
    async setIntro () { // 인트로 페이지 데이터 세팅
      if (window.__wxjs_environment === 'miniprogram') {
        this.time = 0
        this.active = 0
        this.$i18n.locale = 'cn'
        document.title = 'MODNPAY智慧点餐'
      }
      this.$store.dispatch(REQ_MAIN_INDEX)
        .then((res) => {
          if (res.orderGroupPhone) {
            sessionStorage.setItem('orderGroupPhone', res.orderGroupPhone)
          }
          sessionStorage.setItem('freeMemberShipFlag', res.freeMemberShipFlag)
          this.success(res.pageEndFlag)
        })
        .catch(() => { this.fail() })
    },
    success (pageEndFlag) {
      const tempPageType = JSON.parse(localStorage.getItem('pageType'))
      this.pageType = tempPageType ? Number(tempPageType) : 0// 앱 카트 or 관심상품 구분
      setTimeout(() => {
        if (this.pageType == 1) { // 앱 카트에서 진입
          localStorage.setItem('pageType', 0)
          // location.href 사용 시 Store 데이터 사라짐
          const cartInfo = JSON.parse(sessionStorage.getItem('cartInfo'))
          const totalPrice = sessionStorage.getItem('totalPrice')
          sessionStorage.removeItem('cartInfo')
          sessionStorage.removeItem('totalPrice')
          THROW_ORDER(cartInfo, totalPrice)
        } else if (this.pageType === 2) { // 관심상품에서 진입
          localStorage.setItem('pageType', 0)
          THROW_MENU(localStorage.getItem('menuCode'), this.$store.getters.storeCode, this.$store.getters.storeGroupCode)
        } else {
          THROW_MAIN(pageEndFlag, INTRO_PAGE_NAME, undefined)
        }
        // if (this.appFlag) {
        //   const currentURL = window.location.href // URLSearchParams 객체 생성
        //   const params = new URLSearchParams(new URL(currentURL).search) // 파라미터 추출
        //   this.$router.replace({
        //     name: 'MAIN',
        //     query: {
        //       token: params.get('token')
        //     }
        //   })
        // }
      }, this.appFlag ? 0 : this.time)
    },
    fail () {
      // this.$store.commit(NO_BACK_FLAG_ON) // 1. Back Button을 눌러서 상품판 어플리케이션으로 돌아왔을 때
      this.modnPayUrl = this.$store.getters.modnPayUrl
      this.showSingleBtnDialog = true
      this.active = 1
      this.messageType = (this.appFlag) ? MSG_RETURN_BACK_BUTTON_APP : MSG_RETURN_BACK_BUTTON
    }
  }
})
</script>
